
<script>
import JmFilterEntity from './Entity'

export default {
	name: "JmFilterLocation",

	extends: JmFilterEntity
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FilterWidgets/Location.vue